<template>
  <div class="home-page">
    <!-- 视频banner -->
    <div class="video-banner">
      <home-banner :bannerData="bannerList"></home-banner>
    </div>

    <!-- 关于亚科 -->
    <section class="about-section" ref="aboutSection">
      <div class="about-container">
        <div class="about-left">
          <h2 class="section-title" ref="aboutTitle">{{ $t('home.about.title') }}</h2>
          <div class="company-intro">
            <p class="aboutIntro" :class="[currentLanguage === 'zh'? '':'en-p']">
              {{ $t('home.about.subtitle') }}
            </p>
            <p ref="aboutIntro" :class="[currentLanguage === 'zh'? '':'en-p']">
              {{ $t('home.about.description') }}
            </p>
          </div>
          <div class="learn-more-btn btn" ref="learnMoreBtn" @click="routerAbout">
            <span>{{ $t('home.about.learnMore') }}</span>
            <img src="@/assets/images/home_right.png" alt="arrow" class="arrow-icon">
          </div>
        </div>
        <div class="about-right">
          <img v-lazy="'https://file.yacoo.com.cn/staticResource/building.webp?x-oss-process=image/resize,w_890,h_518'" alt="公司大楼" class="building-img" ref="buildingImg">
        </div>
      </div>
    </section>

    <!-- 产品解决方案标题区域 -->
    <div class="solutions-header" style=" background-image: url('https://file.yacoo.com.cn/staticResource/solutionsBanner.png?x-oss-process=image/resize,w_1920');">
      <div class="container">
        <h2 class="section-title">{{ $t('home.solutions.title') }}</h2>
      </div>
      <solutions-swiper :items="solutionItems"></solutions-swiper>
    </div>

    <!--全球服务网络-->
    <section class="global-service"  :style="{ backgroundImage: `url('${bannerBg}')` }">
      <div class="container">
        <h2 class="section-title">{{ $t('home.globalService.title') }}</h2>
        
        <div class="global-content">
          <div class="global-stats">
            <div class="stat-item">
              <p :class="[currentLanguage === 'zh'? '':'en-p']">
                {{ $t('home.globalService.description') }}
              </p>
            </div>
            <div class="stat-item">
              <div class="stat-number">70<span class="unit">+</span></div>
              <div class="stat-desc">{{ $t('home.globalService.stats.team') }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">15000<span class="unit">+</span></div>
              <div class="stat-desc">{{ $t('home.globalService.stats.patents') }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">{{ $t('home.globalService.stats.title') }}<span class="unit"></span></div>
              <div class="stat-desc">{{ $t('home.globalService.stats.capacity') }}</div>
            </div>
          </div>
          <div class="global-map">
            <div class="map-legend">
              <div class="legend-item">
                <div class="legend-icon red" :class="[currentLanguage ==='en'? 'marginTopIcon':'']">
                  <img v-lazy="require('@/assets/images/address_1.png')" alt="marker" />
                </div>
                <div class="legend-label">
                  <span>{{ $t('home.globalService.legend.headquarters.zh') }}</span>
                  <span class="legend-en" v-if="currentLanguage !=='en'">{{ $t('home.globalService.legend.headquarters.en') }}</span>
                </div>
              </div>
              <div class="legend-item">
                <div class="legend-icon blue" :class="[currentLanguage ==='en'? 'marginTopIcon':'']">
                  <img v-lazy="require('@/assets/images/address_2.png')" alt="marker" />
                </div>
                <div class="legend-label">
                  <span>{{ $t('home.globalService.legend.subsidiaries.zh') }}</span>
                  <span class="legend-en"  v-if="currentLanguage !=='en'">{{ $t('home.globalService.legend.subsidiaries.en') }}</span>
                </div>
              </div>
              <div class="legend-item">
                <div class="legend-icon yellow" :class="[currentLanguage ==='en'? 'marginTopIcon':'']">
                  <img v-lazy="require('@/assets/images/address_3.png')" alt="marker" />
                </div>
                <div class="legend-label">
                  <span>{{ $t('home.globalService.legend.customers.zh') }}</span>
                  <span class="legend-en"  v-if="currentLanguage !=='en'">{{ $t('home.globalService.legend.customers.en') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 亚科动态 -->
    <section class="news-section">
      <div class="news-section-box" style=" background-image: url('https://file.yacoo.com.cn/staticResource/news_bg.png?x-oss-process=image/resize,w_1920');">
      <div class="container">
        <div class="news-header">
          <h2 class="section-title">{{ $t('home.news.title') }}</h2>
          <div class="view-more more-btn" @click="handleNewsClick">
            {{ $t('home.news.viewMore') }} <img src="@/assets/images/arrow-right-write.png" alt="arrow" class="arrow-icon">
          </div>
        </div>
        
        <div class="news-swiper-container">
          <div class="swiper-container" ref="newsSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(news, index) in newsList" :key="`news-${news.id}-${index}`">
                <div class="news-card card card--large" @click="goToNewsDetail(news)">
                  <div class="news-image">
                    <template v-if="news.coverType === 'video'">
                      <video
                        class="news-video"
                        :src="news.cover"
                        loop
                        muted
                        @mouseenter="playVideo"
                        @mouseleave="pauseVideo"
                        ref="newsVideo"></video>
                      <div class="video-play-icon">
                        <div class="play-triangle"></div>
                      </div>
                    </template>
                    <img v-else
                       class="el-image"
                       :key="`news-img-${news.id}-${index}`"
                       :src="news.coverSized"
                       :alt="news.title"
                       loading="lazy"
                       decoding="async"
                      />
                  </div>
                  <div class="news-info">
                    <div class="news-date">{{ news.publicTime | timeFilter }}</div>
                    <h3 class="news-title">{{ news.title }}</h3>
                    <p class="news-type">{{ news.newsTypeName }}</p>
                  </div>

                  <!-- 悬停遮罩层 -->
                  <div class="hover-overlay">
                    <div class="overlay-date">{{ news.publicTime | timeFilter }}</div>
                    <h3 class="overlay-title">{{ news.title }}</h3>
                    <p class="overlay-type">{{ news.newsTypeName }}</p>
                    <div class="overlay-detail">
                      {{ $t('home.news.viewDetail') }}
                      <div class="arrow-icon"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="swiper-navigation">
        <div class="swiper-navigation-btn">
          <div class="swiper-button-prev">
            <img src="@/assets/images/left.png" alt="上一页" />
          </div>
          <div class="swiper-button-next">
            <img src="@/assets/images/right.png" alt="下一页" />
          </div>
        </div>
      </div>
    </section>

    <!-- 悬浮功能栏 -->
    <div class="floating-contact-bar" :class="{ 'slide-in': showFloatingBar }">
      <a
        v-for="( item, index ) in contactInfo"
        :key="item.id || index"
        class="contact-item"
        @mouseenter="enterTooltip(index)"
        @mouseleave="leaveTooltip"
      >
        <img :src="item.icon" :alt="item.name">
        <template v-if="item.content && item.content.split(',')">
          <div
            class="tooltip"
            v-if="item.protocol === 'qrcode'"
            :class="{ 'show': activeTooltip === index }"
            @mouseenter="enterTooltip(index)"
            @mouseleave="leaveTooltip"
          >
            <div class="tooltip-header">
              <span class="tooltip-title">{{ item.name }}</span>
            </div>
            <div class="tooltip-content">
              <div class="qrcode-container">
                <img v-for="(i,idx) in item.content.split(',')" :key="idx" :src="i" alt="qrcode" class="qrcode-img" />
              </div>
            </div>
          </div>
          <div
            class="tooltip"
            v-else
            :class="{ 'show': activeTooltip === index }"
            @mouseenter="enterTooltip(index)"
            @mouseleave="leaveTooltip"
          >
            <div class="tooltip-header">
              <span class="tooltip-title">{{ item.name }}</span>
            </div>
            <div class="tooltip-content">
              <div class="contact-info">
                <span v-for="(i,idx) in item.content.split(',')" :key="idx" class="contact-item-text">{{ i }}</span>
              </div>
            </div>
          </div>
        </template>
      </a>
    </div>

  </div>
</template>

<script>
import {getBanner, getProductSolutions} from '@/api'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getNewsList } from '@/api/news'
import {formatDate, getMediaType} from "@/api/common";
import HomeBanner from "@/components/HomeBanner.vue";
import SolutionsSwiper from "@/components/SolutionsSwiper.vue";
import {mapState} from "vuex";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import {getContacts} from "@/api/about";
import {pushWithLanguage} from "@/utils/routeUtils";
import { metaMixin } from "@/utils/metaUtils";
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HomePage',
  mixins: [metaMixin],
  data() {
    return {
      bannerBg: 'https://file.yacoo.com.cn/staticResource/qqfw.png?x-oss-process=image/resize,w_1920',
      solutionItems:[],
      bannerList: [],
      numbers: [
        { value: 10000, unit: '+', label: '专利数量' },
        { value: 10, unit: '万', label: '研发人员' },
        { value: 10000, unit: '㎡', label: '研发基地面积' }
      ],
      solutions: [],
      newsList: [],
      contactInfo: null,
      loading: false,
      animationsInitialized: false,
      isPlaying: false,
      listQuery: {
        current:1,
        size: 10,
        home: 1
      },
      newsSwiper: null,
      showFloatingBar: false, // 控制悬浮栏显示
      scrollThreshold: 0, // 滚动阈值，将在mounted中设置为一个屏幕高度
      activeTooltip: null, // 当前激活的tooltip索引
      tooltipTimer: null,
      aboutAnimationsInitialized: false, // 添加标记避免重复初始化
      newsSlideListeners: [], // 记录新闻轮播悬停事件
    }
  },
  components: {
    HomeBanner,
    SolutionsSwiper
  },
  computed: {
  ...mapState({
      currentLanguage: state => state.app.language
    })
  },
  watch: {
    // 监听语言变化
    currentLanguage: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          // 加载数据
          this.fetchBannerData()
          this.fetchNewsList()
          this.getProductSolutionsData()
          this.fetchContactData()
          this.resetAboutAnimations() // 重置动画状态
          // 更新 metaInfo
          this.$setMetaFromMenuItems(newVal)
        }
      },
      immediate: false
    },
    // 监听路由变化
    '$route': {
      handler() {
        this.$setMetaFromMenuItems()
      },
      immediate: true
    }
  },
  filters: {
    timeFilter(time) {
      //截取年月日
      if( !time ){
        return '--'
      }else{
        return time.substring(0, 10)
      }
    }
  },
  created() {
    this.fetchBannerData()
    this.fetchNewsList()
    this.getProductSolutionsData()
    this.fetchContactData()
  },

  mounted() {
    // 设置 metaInfo
    this.$setMetaFromMenuItems()
    
    // 等待下一个 tick，确保 DOM 已经渲染
    this.$nextTick(() => {
      // 设置滚动阈值为一个屏幕高度
      this.scrollThreshold = window.innerHeight;
      // 添加滚动事件监听
      window.addEventListener('scroll', this.handleScroll);
      // 初始检查滚动位置
      this.handleScroll();
      // 延迟初始化关于亚科板块动画，确保DOM完全渲染
      setTimeout(() => {
        this.initAboutSectionAnimations();
      }, 100);
    });
  },

  metaInfo() {
    // 从 store 中获取 metaInfo，用于预渲染
    const metaInfo = this.$store.state.metaInfo || {}
    return {
      title: metaInfo.title || '生物缓冲剂_体外诊断原辅料_医药中间体_新能源功能材料_亚科股份',
      meta: [
        { name: "keywords", content: metaInfo.keywords || '生物缓冲剂、体外诊断原辅料、医药中间体、新能源功能材料、生物试剂、化学试剂、表面处理功能材料、生物基及特殊功能聚酯、新能源功能材料' },
        { name: "description", content: metaInfo.description || '亚科股份现已形成集研发、生产、销售和服务于一体的国家高新技术企业。业务范围覆盖生物缓冲剂、体外诊断试剂原辅料、医药中间体及药用辅料、新能源功能材料、科研采购电子商务，检测，绿色能源等。' },
      ]
    }
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
    this.removeNewsSwiperHoverHandlers();
  },
  methods: {

    // 获取banner数据
    async fetchBannerData() {
      try {
        this.$loading.show()
        const response = await getBanner();
        this.$loading.hide()
        if (response.success) {
          this.bannerList = response.data.map(item => ({
            ...item,
            type: this.getMediaType(item.url)
          }));
        }
      } catch (error) {
        console.error('获取Banner资源失败:', error);
      }
    },

    // 判断媒体类型
    getMediaType(url) {
      if (!url) return 'image';
      const ext = url.split('.').pop().toLowerCase();
      return ['mp4', 'webm', 'ogg'].includes(ext) ? 'video' : 'image';
    },

    //获取产品与解决方案 数据
    async getProductSolutionsData() {
      try {
        const response = await getProductSolutions();
        if (response.success) {
          this.solutionItems = response.data;
        }
      } catch (error) {
        console.error('获取资源失败:', error);
      }
    },

    //获取右侧悬浮联系数据
    async fetchContactData() {
      try {
        const response = await getContacts({shortcut:1});
        if (response.success) {
          this.contactInfo = response.data;
        }
      } catch (error) {
        console.error('获取资源失败:', error);
      }
    },


    //跳转行业解决方案页面
    handleMoreClick() {
      pushWithLanguage('/industry-solutions', this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error( err)
        }
      })
    },
    //产品中心
    handleProductClick() {
      pushWithLanguage('/products', this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error( err)
        }
      })
    },
    //新闻详情
    goToNewsDetail(item) {
      pushWithLanguage(`/information-center/${item.newsTypeCode}/${item.id}`, this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error( err)
        }
      })
    },

    //跳转新闻列表
    handleNewsClick() {
      pushWithLanguage('/information-center', this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error( err)
        }
      })
    },

    //跳转到关于我们
    routerAbout() {
      pushWithLanguage('/about-yacoo', this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },


    //获取首页新闻列表
    async fetchNewsList() {
      try {
        this.loading = true;
        const response = await getNewsList(this.listQuery);

        if (response.success) {
          this.newsList = response.data.records.map(item => {
            const coverType = item.cover ? getMediaType(item.cover) : 'image';
            return {
              ...item,
              ...formatDate(item.publicTime),
              coverType,
              coverSized: coverType === 'image' ? this.formatCoverUrl(item.cover) : item.cover
            };
          });
          this.total = response.data.total;

          // 数据加载完成后初始化轮播
          this.$nextTick(() => {
            this.initNewsSwiper();
          });
        } else {
          this.$message.error(response.msg || '获取新闻列表失败');
        }
      } catch (error) {
        console.error('获取新闻列表失败:', error);
        this.$message.error('获取新闻列表失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },


    initAnimations() {
      // Banner 动画
      gsap.from('.animate-title', {
        duration: 1.5,
        y: 100,
        opacity: 0,
        ease: 'power4.out'
      })
      
      gsap.from('.animate-subtitle', {
        duration: 1.5,
        y: 50,
        opacity: 0,
        delay: 0.5,
        ease: 'power4.out'
      })

      // 方案卡片动画
      if (this.$refs.solutionsGrid && this.$refs.solutionsGrid.children.length) {
        gsap.from(this.$refs.solutionsGrid.children, {
          scrollTrigger: {
            trigger: this.$refs.solutionsGrid,
            start: 'top 80%'
          },
          y: 100,
          opacity: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power2.out'
        })
      }

      // 新闻列表动画
      if (this.$refs.newsList) {
        const newsItems = this.$refs.newsList.querySelectorAll('.news-item')

        if (newsItems.length) {
          // 新闻列表容器动画
          gsap.from('.news-content', {
            scrollTrigger: {
              trigger: '.news-section',
              start: 'top 80%',
              end: 'bottom 20%',
              toggleActions: 'play none none reverse',
            },
            y: 60,
            opacity: 0,
            duration: 1,
            ease: 'power3.out'
          })

          // 新闻列表项动画
          gsap.from(newsItems, {
            scrollTrigger: {
              trigger: '.news-list',
              start: 'top 80%',
              end: 'bottom 20%',
              toggleActions: 'play none none reverse',
              // markers: true, // 调试用
            },
            y: 30,
            opacity: 0,
            stagger: {
              amount: 0.6,
              from: "start"
            },
            duration: 0.8,
            ease: 'power2.out'
          })

          // 新闻视频区域动画
          const videoSection = document.querySelector('.news-section .news-video')
          if (videoSection) {
            // 视频区域入场动画
            gsap.from(videoSection, {
              scrollTrigger: {
                trigger: videoSection,
                start: 'top 80%',
                end: 'bottom 20%',
                toggleActions: 'play none none reverse',
                // markers: true, // 调试用
              },
              x: 100,
              opacity: 0,
              duration: 1,
              ease: 'power3.out'
            })

            // 视频区域视差效果
            gsap.to(videoSection, {
              scrollTrigger: {
                trigger: '.news-section',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
                // markers: true, // 调试用
              },
              y: 50, // 减小视差距离，使效果更微妙
              ease: 'none'
            })
          }

          // 新闻列表项悬停动画
          newsItems.forEach(item => {
            const hoverTween = gsap.to(item, {
              x: 10,
              duration: 0.3,
              ease: 'power2.out',
              paused: true
            })
            const oldEnter = item._gsapEnter
            const oldLeave = item._gsapLeave
            if (oldEnter) item.removeEventListener('mouseenter', oldEnter)
            if (oldLeave) item.removeEventListener('mouseleave', oldLeave)

            // 添加新的事件监听器
            const enterHandler = () => hoverTween.play()
            const leaveHandler = () => hoverTween.reverse()

            item.addEventListener('mouseenter', enterHandler)
            item.addEventListener('mouseleave', leaveHandler)

            // 存储事件处理函数引用，以便后续可以移除
            item._gsapEnter = enterHandler
            item._gsapLeave = leaveHandler
          })
        }
      }
    },


    // 初始化新闻轮播
    initNewsSwiper() {
      if (this.newsSwiper) {
        this.newsSwiper.destroy();
        this.newsSwiper = null;
      }
      this.$nextTick(() => {
        const vm = this;
        this.newsSwiper = new Swiper(this.$refs.newsSwiper, {
          slidesPerView: 3,
          spaceBetween: 47,
          loop: true,
          loopAdditionalSlides: 3,
          updateOnImagesReady: true,  // 确保图片加载后更新
          observer: true,             // 监视DOM变化
          observeParents: true,       // 监视父元素变化
          preloadImages: true,        // 预加载图片
          watchSlidesProgress: true,  // 监视幻灯片进度
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          navigation: {
            nextEl: '.news-section .swiper-button-next',
            prevEl: '.news-section .swiper-button-prev',
          },
          on: {
            // 初始化后更新布局
            init: function() {
              this.update();
              vm.$nextTick(() => {
                vm.setupNewsSwiperHoverHandlers();
              });
            },
            // 循环创建时的回调函数
            loopCreate: function() {
              // 确保所有图片和视频元素已正确复制
              this.update();
              vm.$nextTick(() => {
                vm.setupNewsSwiperHoverHandlers();
              });
            }
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40
            }
          }
        });
      });
    },

    formatCoverUrl(url) {
      if (!url) return '';
      const resizeParam = 'x-oss-process=image/resize,w_476';
      if (url.includes(resizeParam)) {
        return url;
      }
      return url.includes('?') ? `${url}&${resizeParam}` : `${url}?${resizeParam}`;
    },

    playVideo(e) {
      const video = e.target;
      video.play();
    },
    pauseVideo(e) {
      const video = e.target;
      video.pause();
    },

    // 添加处理滚动的方法
    handleScroll() {
      // 获取当前滚动位置
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      // 如果滚动位置超过一个屏幕高度，显示悬浮栏
      this.showFloatingBar = scrollPosition > this.scrollThreshold;
    },

    // 显示tooltip
    showTooltip(index) {
      this.activeTooltip = index;
    },

    // 初始化关于亚科板块动画
    initAboutSectionAnimations() {
      if (!this.$refs.aboutSection || this.aboutAnimationsInitialized) {
        return;
      }
      
      // 创建主时间轴
      const aboutTl = gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.aboutSection,
          start: "top 80%", 
          end: "bottom 20%",
          toggleActions: "play none none none", // 改为 none，防止反向播放
          markers: false
        }
      });
      
      // 标题动画
      if (this.$refs.aboutTitle) {
        console.log('Adding title animation');
        aboutTl.from(this.$refs.aboutTitle, {
          y: 50,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out"
        });
      }
      
      // 介绍文字动画
      if (this.$refs.aboutIntro) {
        aboutTl.from(this.$refs.aboutIntro, {
          y: 30,
          opacity: 0,
          duration: 0.8,
          ease: "power2.out"
        }, "-=0.4");
      }

      // 添加 learn-more-btn 出现动画
      if (this.$refs.learnMoreBtn) {
        console.log('Adding learn-more-btn animation');
        gsap.from(this.$refs.learnMoreBtn, {
          scrollTrigger: {
            trigger: this.$refs.aboutSection,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none none",
            markers: false
          },
          y: 20,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out"
        });
      }

      // 建筑图片动画
      if (this.$refs.buildingImg) {
        console.log('Adding building image animation');
        aboutTl.from(this.$refs.buildingImg, {
          scale: 0.9,
          x: 50,
          opacity: 0,
          duration: 1.2,
          ease: "power2.out"
        }, "-=0.8");
        
        // 图片视差效果
        gsap.to(this.$refs.buildingImg, {
          scrollTrigger: {
            trigger: this.$refs.aboutSection,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.5
          },
          y: -40,
          ease: "none"
        });
      }
      
      // 初始化 learn-more-btn 动画
      this.addLearnMoreBtnListeners();
      
      // 标记动画已初始化
      this.aboutAnimationsInitialized = true;
      console.log('Animation initialization completed');
    },
    enterTooltip(index) {
      clearTimeout(this.tooltipTimer)
      this.activeTooltip = index
    },
    leaveTooltip() {
      this.tooltipTimer = setTimeout(() => {
        this.activeTooltip = null
      }, 150)
    },

    // 添加了解更多按钮的事件监听器
    addLearnMoreBtnListeners() {
      if (!this.$refs.learnMoreBtn) {
        return;
      }
      
      const arrowIcon = this.$refs.learnMoreBtn.querySelector('.arrow-icon');
      const buttonText = this.$refs.learnMoreBtn.querySelector('span');
      
      if (!arrowIcon) {
        return;
      }
      
      const mouseenterHandler = () => {
        
        // 创建悬停动画时间轴
        const hoverTl = gsap.timeline();
        
        // 按钮整体缩放和颜色变化
        hoverTl.to(this.$refs.learnMoreBtn, {
          scale: 1,
          duration: 0.3,
          ease: "power2.out"
        }, 0);
        
        // 箭头移动动画
        hoverTl.to(arrowIcon, {
          x: 12,
          duration: 0.4,
          ease: "power2.out"
        }, 0);
        
        // 文字颜色变化
        if (buttonText) {
          hoverTl.to(buttonText, {
            duration: 0.3,
            ease: "power2.out"
          }, 0);
        }
        
        // 添加按钮阴影效果
        hoverTl.to(this.$refs.learnMoreBtn, {
          duration: 0.3,
          ease: "power2.out"
        }, 0);
      };
      
      const mouseleaveHandler = () => {
        // 创建离开动画时间轴
        const leaveTl = gsap.timeline();
        
        // 恢复按钮状态
        leaveTl.to(this.$refs.learnMoreBtn, {
          scale: 1,
          duration: 0.3,
          ease: "power2.out"
        }, 0);
        
        // 恢复箭头位置
        leaveTl.to(arrowIcon, {
          x: 0,
          duration: 0.4,
          ease: "power2.out"
        }, 0);
        
        // 恢复文字颜色
        if (buttonText) {
          leaveTl.to(buttonText, {
            duration: 0.3,
            ease: "power2.out"
          }, 0);
        }
      };
      
      // 存储监听器引用
      this.learnMoreBtnListeners = {
        element: this.$refs.learnMoreBtn,
        mouseenter: mouseenterHandler,
        mouseleave: mouseleaveHandler
      };
      
      // 添加事件监听器
      this.$refs.learnMoreBtn.addEventListener("mouseenter", mouseenterHandler);
      this.$refs.learnMoreBtn.addEventListener("mouseleave", mouseleaveHandler);
    },

    // 移除了解更多按钮的事件监听器
    removeLearnMoreBtnListeners() {
      if (this.learnMoreBtnListeners) {
        const { element, mouseenter, mouseleave } = this.learnMoreBtnListeners;
        if (element) {
          element.removeEventListener("mouseenter", mouseenter);
          element.removeEventListener("mouseleave", mouseleave);
        }
        this.learnMoreBtnListeners = null;
      }
    },

    setupNewsSwiperHoverHandlers() {
      this.removeNewsSwiperHoverHandlers();
      if (!this.$refs.newsSwiper) {
        return;
      }
      const slides = this.$refs.newsSwiper.querySelectorAll('.swiper-slide');
      slides.forEach(slide => {
        const enterHandler = () => {
          if (this.newsSwiper && this.newsSwiper.autoplay) {
            this.newsSwiper.autoplay.stop();
          }
        };
        const leaveHandler = () => {
          if (this.newsSwiper && this.newsSwiper.autoplay) {
            this.newsSwiper.autoplay.start();
          }
        };
        slide.addEventListener('mouseenter', enterHandler);
        slide.addEventListener('mouseleave', leaveHandler);
        this.newsSlideListeners.push({
          element: slide,
          enterHandler,
          leaveHandler
        });
      });
    },
    removeNewsSwiperHoverHandlers() {
      if (!this.newsSlideListeners.length) return;
      this.newsSlideListeners.forEach(({element, enterHandler, leaveHandler}) => {
        if (!element) return;
        element.removeEventListener('mouseenter', enterHandler);
        element.removeEventListener('mouseleave', leaveHandler);
      });
      this.newsSlideListeners = [];
    },

    // 重置动画状态（在语言切换时调用）
    resetAboutAnimations() {
      this.aboutAnimationsInitialized = false;
      this.removeLearnMoreBtnListeners();
      
      // 清除所有相关的 GSAP 动画
      if (this.$refs.aboutSection) {
        ScrollTrigger.getAll().forEach(trigger => {
          if (trigger.vars.trigger === this.$refs.aboutSection) {
            trigger.kill();
          }
        });
      }
      
      // 重置元素状态
      if (this.$refs.learnMoreBtn) {
        gsap.set(this.$refs.learnMoreBtn, { clearProps: "all" });
      }
      if (this.$refs.aboutTitle) {
        gsap.set(this.$refs.aboutTitle, { clearProps: "all" });
      }
      if (this.$refs.aboutIntro) {
        gsap.set(this.$refs.aboutIntro, { clearProps: "all" });
      }
      if (this.$refs.buildingImg) {
        gsap.set(this.$refs.buildingImg, { clearProps: "all" });
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.home-page {
  .section {
    padding: 80px 0;
  }

  .video-banner {
    position: relative;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: #000;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .about-section {
    position: relative;
    padding: 146px 0 80px;
    background: #fff;
    overflow: hidden;
    
    /* 添加背景元素 */
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      right: -200px;
      width: 800px;
      height: 800px;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(25, 82, 159, 0.05), rgba(25, 82, 159, 0));
      z-index: 0;
      transform: translateY(-50%);
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: -200px;
      left: -200px;
      width: 600px;
      height: 600px;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(226, 110, 118, 0.05), rgba(226, 110, 118, 0));
      z-index: 0;
    }
  }

  .about-container {
    max-width: 1520px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    gap: 50px;
    @media (max-width: @screen-md) {
      flex-direction: column;
      padding: 0 15px;
    }
  }

  .about-left {
    flex: 1;
    padding-right: 30px;
    position: relative;
    z-index: 10;

    @media (max-width: @screen-md) {
      flex: 0 0 100%;
      padding-right: 0;
      margin-bottom: 30px;
      order: 2;
    }

    .company-intro {
      margin: 30px 0;
      
      p {
        font-size: @font-size-note;
        line-height: @spacing-sm;
        color: #7A7A7A;
        margin-bottom: 20px;
        text-align: justify;
      }
    }

    .learn-more-btn {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 0 !important;
      span {
        font-size: @font-size-note;
        color: rgba(226, 110, 118, 1);
        margin-right: 8px;

        transition: color 0.3s ease;
      }
      
      .arrow-icon {
        width: 25px;
        height: 11px;
        transition: transform 0.3s ease;
      }
    }
  }

  .about-right {
    flex-shrink: 0;
    width: 890px;
    height: auto;
    display: flex;
    justify-content: flex-end;

    @media (max-width: @screen-md) {
      flex: 0 0 100%;
      justify-content: center;
      order: 1;
    }

    .building-img {
      width: 100%;
      height: auto;
    }
  }

  .solutions-header {
    background-color: #fff;
    padding: 140px 0 30px;
    background-repeat: no-repeat;
    background-size: cover;

    .container {
      max-width: 1520px;
      margin: 0 auto 120px;
      padding: 0;
    }

    .section-subtitle {
      text-align: left;
      color: #666;
      font-size: @font-size-note;
      margin-bottom: 0;
    }
  }
  .news-section {
    background: #fff;
    padding: 80px 0;
    overflow: hidden;
    .news-section-box{
      padding-top: 120px;
      background-repeat: no-repeat;
      background-position: center;
    }
    .container {
      max-width: 1520px;
      margin: 0 auto;
      padding: 0;
      
      .news-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 60px;
        
        .section-title {
          margin-bottom: 40px;
          color: #fff;
          
          &:after {
            content: '';
            position: absolute;
            bottom: -20px;
            left: 0;
            width: 204px;
            height: 8px;
            background: linear-gradient( 270deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
          }
        }
        
        .view-more {
          display: flex;
          align-items: center;
          color: #fff;
          font-size: @font-size-note;
          cursor: pointer;
          
          .arrow-icon {
            width: 25px;
            height: 11px;
            margin-left: 8px;
            transition: transform 0.3s ease;
          }
          
          &:hover .arrow-icon {
            transform: translateX(5px);
          }
        }
      }
    }

    .news-swiper-container {
      position: relative;
      padding: 0 0 10px;
      
      .swiper-container {
        overflow: hidden;
        padding: 0 0 40px;
        
        .swiper-wrapper {
          align-items: stretch;
        }
        
        .swiper-slide {
          height: auto;
        }
      }
      
      .news-card {
        height: 100%;
        background: #fff;
        border-radius: 20px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
        cursor: pointer;
        transition: transform 0.3s ease;
        position: relative;
        z-index: 6;
        &:hover {
          .hover-overlay {
            opacity: 1;
          }
          &::after {
            content: ' ';
            display: block;
            height: 60px;
            border-radius: 20px;
            background: #E26E76;
            position: absolute;
            bottom: -6px;
            left: 0;
            right: 0;
            z-index: 0 !important;
            box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          }

        }
        
        .hover-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #19529F;
          opacity: 0;
          border-radius: 20px;
          z-index: 10;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 76px 48px 40px;
          overflow: auto;
          //overflow: hidden;
          .overlay-date {
            color: #fff;
            font-size: @font-size-note;
            margin-bottom: 51px;
          }
          
          .overlay-title {
            color: #fff;
            font-size: @font-size-note;

            line-height: 1.4;
            margin-bottom: 30px;
            max-height: 130px;
            overflow: hidden;
            display: -webkit-box;
            line-clamp: 3;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          
          .overlay-type {
            color: rgba(255, 255, 255, 0.7);
            font-size: @font-size-note;
            margin-bottom: 20px;
          }
          
          .overlay-detail {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;
            font-size: @font-size-note;
            margin-top: auto;
            
            .arrow-icon {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background-color: #fff;
              margin-left: 10px;
              
              &::after {
                content: '';
                width: 24px;
                height: 24px;
                background-image: url('@/assets/images/arrow-right.png');
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                filter: brightness(0) saturate(100%) invert(23%) sepia(62%) saturate(1090%) hue-rotate(189deg) brightness(92%) contrast(89%);
              }
            }
          }
        }
        
        .news-image {
          position: relative;
          width: 100%;
          height: 280px;
          overflow: hidden;
          border-radius: 20px;
          
          .el-image, .news-video {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          
          .video-play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            background-color: rgba(25, 82, 159, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 2;
            pointer-events: none;
            opacity: 0.9;
            transition: opacity 0.3s ease, transform 0.3s ease;
            
            .play-triangle {
              width: 0;
              height: 0;
              border-style: solid;
              border-width: 10px 0 10px 18px;
              border-color: transparent transparent transparent #ffffff;
              margin-left: 4px; /* 微调使三角形居中 */
            }
          }
          
          &:hover {
            .video-play-icon {
              opacity: 0.5;
              transform: translate(-50%, -50%) scale(1.1);
            }
          }
        }
        
        .news-info {
          padding: 40px 55px;
          transition: all 0.3s ease;
          .news-date {
            font-size: @font-size-note;
            color: #123769;
            line-height: 16px;
            text-align: left;
            margin-bottom: 16px;
          }
          .news-title {
            font-size: @font-size-content;
            color: #123769;
            line-height: 32px;
            text-align: left;
            height: 68px;
            overflow: hidden;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            transition: color 0.3s ease;
            margin-bottom: 30px;
          }
          
          .news-type {
            font-size: @font-size-note;
            color: #123769;
            line-height: 16px;
            text-align: left;
            transition: color 0.3s ease;
          }
        }
      }
    }
    
    .swiper-navigation {
      position: relative;
      z-index: 10;
      width: 100%;
      max-width: 1520px;
      margin: 0 auto;
      height: 140px;
      
      .swiper-navigation-btn {
        position: absolute;
        bottom: 0;
        right: 0;
        display: flex;
        &::before{
          content: '';
          position: absolute;
          width: 1154px;
          height: 0px;
          border: 1px solid;
          border-image: linear-gradient(270deg, rgba(25, 82, 159, 1), rgba(226, 110, 118, 0.13)) 1 1;
          left: -1184px;
          top: 50%;
          margin-top: -1px;
        }
        .swiper-button-prev,
        .swiper-button-next {
          position: relative;
          top: auto;
          left: auto;
          right: auto;
          bottom: auto;
          margin: 0;
          width: 162px;
          height: 68px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 39px;
          cursor: pointer;
          
          img {
            width: 38px;
            height: 30px;
          }
          
          &:after {
            display: none;
          }
        }
        
        .swiper-button-prev {
          background: #FFFFFF;
          box-shadow: 0 2px 17px 0 rgba(50, 85, 117, 0.18);
        }
        
        .swiper-button-next {
          margin-left: 15px;
          background: #19529F;
          box-shadow: 0 2px 17px 2px rgba(60, 92, 167, 0.5);
        }
      }
    }
  }
}

.section-desc {
  font-size: @font-size-note;
  color: #666;
  margin-bottom: 40px;
  text-align: left;
}

.loading {
  text-align: center;
  padding: 40px 0;
  color: @text-color-secondary;
  font-size: @font-size-note;
}

.global-service {
  background-color: #fff;
  padding: 100px 0 80px;
  position: relative;
  background-repeat: no-repeat;
  background-size: 100% 90%;
  background-position: right center;
  .container {
    max-width: 1520px;
    margin: 0 auto;
    padding: 0;
    position: relative;
  }
  
  .global-content {
    display: flex;
    
    @media (max-width: 992px) {
      flex-direction: column;
    }
  }
  
  .global-stats {
    display: flex;
    flex-direction: column;
    flex: 0 0 28%;
    flex-shrink: 0;
    padding: 0px 0 0 0;
    
    .stat-item {
      margin-bottom: 67px;
       p{
         font-family: PingFangSC, PingFang SC;
         font-weight: 400;
         font-size: @font-size-note;
         color: #7A7A7A;
         line-height: 35px;
         text-align: justify;
         font-style: normal;
       }
      .stat-number {
        font-size: 48px;
        color: #E26E76;
        margin-bottom: 10px;
        line-height: 1;
        display: block;

        
        .unit {
          font-size: @font-size-content;
          margin-left: 2px;

        }
      }
      
      .stat-desc {
        font-size: @font-size-note;
        color: #19529F;
        line-height: 1.5;
        font-weight: normal;
        display: block;
      }
    }
    .stat-item:last-child {
      margin-bottom: 0;
    }
  }
  
  .global-map {
    flex: 1;
    position: relative;
    max-width: 75%;
    
    img {
      width: 100%;
      height: auto;
      display: block;
    }
    
    .map-legend {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: flex-end;
      padding: 15px 0;
      
      .legend-item {
        display: flex;
        align-items: center;
        margin: 0 30px 0 0;
        
        .legend-icon {
          width: 27px;
          height: 34px;
          margin-top: -12px;
          img{
            width: 100%;
            height: auto;
          }
        }
        .marginTopIcon{
          margin-top: 0 !important;
        }

        .legend-label {
          margin-left: 20px;
          span {
            font-size: @font-size-content;
            color: var(--primary-color);

            text-align: left;
            display: block;
          }

          .legend-en {
            font-size: @font-size-note;
            color: var(--primary-color);
            margin-top: 2px;
          }
        }

      }
    }
  }
  
  @media (max-width: 992px) {
    .global-stats {
      max-width: 100%;
      flex: 0 0 100%;
      margin-bottom: 40px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      
      .stat-item {
        flex: 0 0 30%;
        padding-right: 15px;
      }
    }
    
    .global-map {
      max-width: 100%;
    }
  }
}

.floating-contact-bar {
  position: fixed;
  right: -80px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 15px 0;
  transition: right 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  visibility: hidden;
  
  &.slide-in {
    right: 20px;
    opacity: 1;
    visibility: visible;
  }
  
  .contact-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    position: relative;
    transition: all 0.3s ease;
    cursor: pointer;
    
    img {
      width: 26px;
      height: auto;
      transition: all 0.3s ease;
    }
    
    &:hover {
      background-color: rgba(25, 82, 159, 0.1);
      
      img {
        transform: scale(1.1);
      }
    }
    
    .tooltip {
      position: absolute;
      right: 70px;
      background: #FFFFFF;
      color: #333;
      border-radius: 8px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      opacity: 0;
      transform: translateX(20px) scale(0.9);
      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      pointer-events: none;
      min-width: 200px;
      max-width: 280px;
      z-index: 1000;
      
      &.show {
        opacity: 1;
        transform: translateX(-10px) scale(1);
        pointer-events: auto;
      }
      
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: -8px;
        transform: translateY(-50%);
        border-width: 8px 0 8px 8px;
        border-style: solid;
        border-color: transparent transparent transparent #FFFFFF;
        filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.1));
      }
      
      .tooltip-header {
        padding: 12px 16px 8px;
        border-bottom: 1px solid #F0F0F0;
        
        .tooltip-title {
          font-size: @font-size-note;
          font-weight: 600;
          color: #19529F;
          display: block;
        }
      }
      
      .tooltip-content {
        padding: 12px 16px;
        
        .qrcode-container {
          display: flex;
          flex-direction: column;
          gap: 8px;
          align-items: center;
          
          .qrcode-img {
            width: 120px;
            height: 120px;
            border-radius: 4px;
            border: 1px solid #E8E8E8;
            object-fit: cover;
            
            &:hover {
              transform: scale(1.05);
              transition: transform 0.2s ease;
            }
          }
        }
        
        .contact-info {
          display: flex;
          flex-direction: column;
          gap: 6px;
          
          .contact-item-text {
            font-size: 14px;
            color: #666;
            line-height: 1.4;
            word-break: break-all;
            white-space: normal;
            
            &:hover {
              color: #19529F;
              transition: color 0.2s ease;
            }
          }
        }
      }
      
      // 添加tooltip悬停效果
      &:hover {
        transform: translateX(-10px) scale(1.02);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
      }
    }
  }
  
  @media (max-width: 768px) {
    right: -60px; // 移动端初始位置
    
    &.slide-in {
      right: 10px;
    }
    
    .contact-item {
      width: 50px;
      height: 50px;
      
      img {
        width: 22px;
        height: 22px;
      }
      
      .tooltip {
        right: 60px;
        min-width: 180px;
        max-width: 240px;
        
        .tooltip-content {
          .qrcode-container {
            .qrcode-img {
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }
}

</style> 